module.exports = __webpack_public_path__ + "media/images/nav_social/facebook (1)-e44d4dd6594e6ae6718a89059f29cdc7.svg";